// extracted by mini-css-extract-plugin
export var checkboxInputRow = "F_vP";
export var checkboxInputColumn = "F_vQ";
export var inputOptionRow = "F_sR";
export var inputOptionColumn = "F_sS";